
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".8","y":".8","width":"62.4","height":"46.4","rx":".8","stroke":"currentColor","stroke-width":"1.6"}}),_c('rect',{attrs:{"x":"6","y":"9","width":"52","height":"6","rx":".8","fill":"currentColor"}}),_c('rect',{attrs:{"x":"6","y":"17","width":"12.235","height":"6","rx":".8","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"19.255","y":"17","width":"12.235","height":"6","rx":".8","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"32.51","y":"17","width":"12.235","height":"6","rx":".8","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"45.765","y":"17","width":"12.235","height":"6","rx":".8","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"6","y":"25","width":"12.235","height":"6","rx":".8","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"19.255","y":"25","width":"12.235","height":"6","rx":".8","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"32.51","y":"25","width":"12.235","height":"6","rx":".8","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"45.765","y":"25","width":"12.235","height":"6","rx":".8","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"6","y":"33","width":"12.235","height":"6","rx":".8","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"19.255","y":"33","width":"12.235","height":"6","rx":".8","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"32.51","y":"33","width":"12.235","height":"6","rx":".8","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"45.765","y":"33","width":"12.235","height":"6","rx":".8","fill":"#E0E2E6"}})])
          )
        }
      }
    